"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var resolveValue = function resolveValue(obj, value) {
  var parentKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if ((0, _isString.default)(value) && value.startsWith('$.')) {
    var loopSearchPath = "$.".concat(parentKeys.join('.'));
    var searchPath = value;
    var keyHistory = [searchPath];
    var currentSearchPath = searchPath;

    while ((0, _isString.default)(currentSearchPath) && currentSearchPath.startsWith('$.') && currentSearchPath !== loopSearchPath) {
      currentSearchPath = (0, _get.default)(obj, currentSearchPath.replace('$.', ''), null);
      keyHistory.push(currentSearchPath);
    }

    if (currentSearchPath === loopSearchPath) {
      keyHistory.unshift(keyHistory[keyHistory.length - 1]);
      keyHistory.pop();
      throw new Error("Cannot resolve object. ".concat(keyHistory.join(' > '), " are circularly referenced to ").concat(loopSearchPath, "."));
    }

    return currentSearchPath;
  } else return value;
};

var resolveArray = function resolveArray(obj, arr) {
  var parentKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return arr.map(function (item, index) {
    if ((0, _isObject.default)(item)) {
      return resolveObject(obj, item, _toConsumableArray(parentKeys).concat([index.toString()]));
    } else if ((0, _isArray.default)(item)) {
      return resolveArray(obj, item, _toConsumableArray(parentKeys).concat([index.toString()]));
    } else {
      return resolveValue(obj, item, _toConsumableArray(parentKeys).concat([index.toString()]));
    }
  });
};

var resolveObject = function resolveObject(parentObj, obj) {
  var parentKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return Object.keys(obj).reduce(function (result, key) {
    var value = obj[key];

    if ((0, _isObject.default)(value)) {
      result[key] = resolveObject(parentObj, value, _toConsumableArray(parentKeys).concat([key]));
    } else if ((0, _isArray.default)(value)) {
      result[key] = resolveArray(parentObj, value, _toConsumableArray(parentKeys).concat([key]));
    } else {
      result[key] = resolveValue(parentObj, value, _toConsumableArray(parentKeys).concat([key]));
    }

    return result;
  }, {});
};

var resolve = function resolve(obj) {
  return resolveObject(obj, obj);
};

var _default = resolve;
exports.default = _default;
module.exports = exports.default;